import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
  className?: string;
}

export const LoadingState = ({
  message = "Loading...",
  fullScreen = false,
  className,
}: LoadingStateProps) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 animate-fade-in",
        fullScreen && "min-h-screen",
        !fullScreen && "py-12",
        className
      )}
    >
      <Loader2 className="w-8 h-8 text-primary animate-spin" />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
};

interface ContentLoaderProps {
  lines?: number;
  className?: string;
}

export const ContentLoader = ({ lines = 3, className }: ContentLoaderProps) => {
  return (
    <div className={cn("space-y-3 animate-pulse", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="h-4 bg-muted rounded"
          style={{
            width: `${100 - (i * 10)}%`,
            animationDelay: `${i * 100}ms`,
          }}
        />
      ))}
    </div>
  );
};
